import { BackToTop } from '@hue/design-system';
import type { ProfessionalsView } from '../../app/list-views.js';
import { PageHeader } from '../../app/page-title.js';
import type { ViewSetter } from '../../app/view-state.js';
import { ResourcesPanel, type ResourceListView } from './resources-panel.js';

/// O cadastro de quem trabalha na unidade (ADR 0083). O dado continua sendo da Agenda: a tela mora
/// fora dela porque a ficha também trata de vínculo, comissão e vales, e nem todo profissional atende.
export function CompanyProfessionals({
  canManage,
  timeZone,
  view,
  onView,
}: {
  canManage: boolean;
  timeZone: string;
  view: ProfessionalsView;
  onView: ViewSetter<ProfessionalsView>;
}) {
  const { professional, ...rest } = view;
  return (
    <section aria-labelledby="company-professionals-title">
      <PageHeader
        trail="Operação / Profissionais"
        id="company-professionals-title"
        title="Profissionais"
        description="Quem atende e quem recebe comissão nesta unidade, com serviços, horários e vínculo de trabalho."
      />
      <ResourcesPanel
        kind="PROFESSIONAL"
        canManage={canManage}
        timeZone={timeZone}
        view={{ ...rest, open: professional }}
        onView={({ open, ...patch }: Partial<ResourceListView>, options) =>
          onView({ ...patch, ...(open === undefined ? {} : { professional: open }) }, options)
        }
      />
      <BackToTop />
    </section>
  );
}
